// Copy in Sanity writes the split as this placeholder; sanityFetch swaps it for
// the Profit Split singleton. Stega appends at the end of a string, so it survives.
export const PROFIT_SPLIT_MARKER = '{profitSplit}';

// Shown only if the field is cleared after texts were rewritten.
export const PROFIT_SPLIT_FALLBACK = 90;

export const PROFIT_SPLIT_QUERY = `*[_type == "profitSplitSettings" && _id == "profitSplitSettings"][0].profitSplit`;

export function resolveProfitSplit(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value > 0 && value <= 100
    ? value
    : null;
}

export function containsProfitSplitMarker(value: unknown): boolean {
  if (typeof value === 'string') return value.includes(PROFIT_SPLIT_MARKER);
  if (Array.isArray(value)) return value.some(containsProfitSplitMarker);
  if (value && typeof value === 'object') {
    return Object.values(value).some(containsProfitSplitMarker);
  }
  return false;
}

// Returns the same reference for branches without the placeholder.
export function replaceProfitSplitMarker<T>(value: T, split: number): T {
  if (typeof value === 'string') {
    return (
      value.includes(PROFIT_SPLIT_MARKER)
        ? value.split(PROFIT_SPLIT_MARKER).join(String(split))
        : value
    ) as T;
  }
  if (Array.isArray(value)) {
    let changed = false;
    const next = value.map((item) => {
      const replaced = replaceProfitSplitMarker(item, split);
      if (replaced !== item) changed = true;
      return replaced;
    });
    return (changed ? next : value) as T;
  }
  if (value && typeof value === 'object') {
    let changed = false;
    const next: Record<string, unknown> = {};
    for (const [key, item] of Object.entries(value)) {
      const replaced = replaceProfitSplitMarker(item, split);
      if (replaced !== item) changed = true;
      next[key] = replaced;
    }
    return (changed ? next : value) as T;
  }
  return value;
}
